<div class="table-container" *ngIf="pessoaId">
    <div id="mainDiv">
        <!-- <p-dropdown [options]="tipoItemOptions" [(ngModel)]="tipoItemSelecionado" optionLabel="label"
            placeholder="Tipo de Item" /> -->
        <div class="p-iconField">
            <!-- <p-iconField iconPosition="right">
                <p-inputIcon class="icon-search-button" styleClass="pi pi-search" (click)="search()" />
                <input class="input-field" [(ngModel)]="searchCodigo" (keydown)="onKeyDown($event)" type="text"
                    pInputText placeholder="Pesquisar pelo nome do item" />
            </p-iconField> -->
        </div>
    </div>

    <p-table [value]="items" class="table-style" [customSort]="true" (sortFunction)="customSort($event)">
        <ng-template class="ct-tr" pTemplate="header">
            <tr>
                <th pSortableColumn="id">ID <p-sortIcon field="id" /> </th>
                <th>{{headers.imagem}}</th>
                <th pSortableColumn="nome">{{headers.nome}} <p-sortIcon field="nome" /> </th>
                <th pSortableColumn="codigoItem">{{headers.codigo_item}} <p-sortIcon field="codigoItem" /> </th>
                <th pSortableColumn="barras">{{headers.codigo_barras}} <p-sortIcon field="barras" /> </th>
                <th pSortableColumn="custo">{{headers.custo}} <p-sortIcon field="custo" /> </th>
                <th pSortableColumn="precoDeVenda">{{headers.preco_venda}} <p-sortIcon field="precoDeVenda" /> </th>
                <th pSortableColumn="saldo">{{headers.saldo}} <p-sortIcon field="saldo" /> </th>
                <th pSortableColumn="estoqueMinimo">{{headers.estoque_minimo}} <p-sortIcon field="estoqueMinimo" /> </th>
                <th pSortableColumn="tipoDeImposto">{{headers.tipo_imposto}} <p-sortIcon field="tipoDeImposto" /> </th>
                <th pSortableColumn="tipoDeDesconto">{{headers.tipo_desconto}} <p-sortIcon field="tipoDeDesconto" /> </th>
                <th pSortableColumn="desconto">{{headers.desconto}} <p-sortIcon field="desconto" /> </th>
                <th pSortableColumn="criadoEm">{{headers.data_criacao}} <p-sortIcon field="criadoEm" /> </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.id }}</td>
                <td>
                    <img style="width: 24px; height: 24px; cursor: pointer;"
                        src="https://cdn-icons-png.flaticon.com/512/3069/3069201.png" alt="Image" height="16" />
                </td>
                <td>{{ item.nome }}</td>
                <td>{{ item.codigoItem }}</td>
                <td>{{ item.barras }}</td>
                <td>{{ item.custo | currency }}</td>
                <td>{{ item.precoDeVenda | currency }}</td>
                <td>{{ item.saldo }}</td>
                <td>{{ item.estoqueMinimo }}</td>
                <td>{{ item.tipoDeImposto }}</td>
                <td>{{ item.tipoDeDesconto }}</td>
                <td>{{ item.desconto | percent }}</td>
                <td>{{ item.criadoEm | date:'short' }}</td>

            </tr>
        </ng-template>
    </p-table>

    <div class="pagination-container">
        <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>

        <span class="mx-1 text-color">{{texts.itens_por_pagina}} </span>
        <p-dropdown [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()"></p-dropdown>
    </div>
</div>
